export enum VIEW {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  GROSS = 'GROSS',
  NET = 'NET'
}

export enum LEAVE_TYPES {
  PLANNED_LEAVE = 'PLANNED_LEAVE',
  PREDICTED_LEAVE = 'PREDICTED_LEAVE',
  PLANNED_AND_REQUESTED_LEAVE = 'PLANNED_AND_REQUESTED_LEAVE'
}
